<template>
  <a href="#" @click.prevent="$emit('less')">
    <small>show less -</small>
  </a>
</template>

<script>
export default {}
</script>
